import axiosInstanceNew from "../lib/axiosinstanceNew";

const ProductModel = class {

  async List(query = []) {
    return (await axiosInstanceNew.get(`product?${new URLSearchParams(query)}`));
  }

  async Detail(productId) {
    return (await axiosInstanceNew.get(`product/${productId}`));
  }

  async Add(data) {
    return await axiosInstanceNew.post("product", data);
  }

  async Update(productId, data) {
    return await axiosInstanceNew.put(`product/${productId}`, data);
  }

  async Delete(productId) {
    return await axiosInstanceNew.delete(`product/${productId}`);
  }

  async checkApi() {
    return (await axiosInstanceNew.get(`tutor_enquiry`));
  }
  
  async productenqLists(query = []) {
    return (await axiosInstanceNew.get(`product_enquiry?${new URLSearchParams(query)}`));
  }


};

export default new ProductModel();

